// extracted by mini-css-extract-plugin
export var partners = "partners-module--partners--fd410";
export var partners__container = "partners-module--partners__container--def0d";
export var partners__item = "partners-module--partners__item--53bc8";
export var partners__list = "partners-module--partners__list--1c0b1";